<script lang="ts">
import { defineComponent } from 'vue';
import type { CreatePoolType } from '@/types/pools';
import { validateNumber } from '@/components/pools/helpers';
import { mapActions } from 'pinia';
import { usePoolsStore } from '@/stores/pools';

export default defineComponent({
  name: 'types-add',
  data() {
    return {
      newPoolType: {} as CreatePoolType,
      showAddPool: false,
    };
  },
  methods: {
    validateNumber,
    ...mapActions(usePoolsStore, ['fetchPoolTypes', 'createPoolType']),
    async createNewPoolType() {
      return this.createPoolType(this.newPoolType).then(() => this.fetchPoolTypes());
    },
  },
});
</script>

<template>
  <tr>
    <td><i class="pi pi-file-plus" /></td>
    <td class="!px-0 !py-0">
      <input type="text" class="required" v-model="newPoolType.name" placeholder="Название" />
    </td>
    <td class="!px-0 !py-0">
      <input
        type="number"
        @focusout="newPoolType.stakeMin = validateNumber(newPoolType.stakeMin)"
        v-model="newPoolType.stakeMin"
        placeholder="Мин.ставка"
      />
    </td>
    <td class="!px-0 !py-0">
      <input
        type="number"
        @focusout="newPoolType.stakeMax = validateNumber(newPoolType.stakeMax)"
        v-model="newPoolType.stakeMax"
        placeholder="Макс.ставка"
      />
    </td>
    <td class="!px-0 !py-0">
      <input
        type="number"
        class="required"
        @focusout="newPoolType.stakesCount = validateNumber(newPoolType.stakesCount)!"
        v-model="newPoolType.stakesCount"
        placeholder="Кол-во событий"
      />
    </td>
    <td class="!px-0 !py-0">
      <input
        type="number"
        class="required"
        @focusout="newPoolType.commission = validateNumber(newPoolType.commission)!"
        v-model="newPoolType.commission"
        placeholder="Комиссия системы"
      />
    </td>
    <td>
      <i class="pi pi-plus-circle text-green-500 pt-1 cursor-pointer" @click="createNewPoolType" />
    </td>
  </tr>
</template>

<style lang="scss" scoped>
input {
  @apply w-full bg-transparent focus:border-none focus:outline-dotted text-center placeholder:font-thin placeholder:italic py-2;
}

.required {
  @apply placeholder-yellow-500;
}
</style>
